export const validSearchArrayItems = <T>(items?: T[]): boolean => {
  return Boolean(items && items.length > 0);
};
